import { render, staticRenderFns } from "./AlcoholNonExcisesTransactions.vue?vue&type=template&id=6e881d8a&"
import script from "./AlcoholNonExcisesTransactions.vue?vue&type=script&lang=js&"
export * from "./AlcoholNonExcisesTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports